import { combineReducers } from "redux";
import ui from "./uiReducer";
import dlists from "../Dlists/store/dlistsReducer";
import entities from "./entities";

export default combineReducers({
  ui,
  entities,
  dlists
});
